(() => {
/**
 * Google Tag Manager
 */ (function(window1, document1, i) {
    window1["dataLayer"] = window1[dataLayer] || [];
    window1["dataLayer"].push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js"
    });
    var firstScript = document1.getElementsByTagName("script")[0];
    var gtmScript = document1.createElement("script");
    var dataLayer = "";
    gtmScript.async = true;
    // Original
    gtmScript.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dataLayer;
    firstScript.parentNode.insertBefore(gtmScript, firstScript);
})(window, document, "GTM-K4CNSNHM");

})();
//# sourceMappingURL=gtag.js.map
